export default [
  {
    name: 'costingManagement',
    label: 'labels.costingManagement',
    permissionKey: 'costing_management',
    children: [
      {
        name: 'costingCostingManagement',
        label: 'labels.costingManagementOther',
        permissionKey: 'costing_costing_management',
        children: [
          {
            name: 'addCosting',
            label: 'labels.addCosting',
            permissionKey: 'costing_costing_add'
          },
          {
            name: 'editCosting',
            label: 'labels.editCosting',
            permissionKey: 'costing_costing_edit'
          },
          {
            name: 'deleteCosting',
            label: 'labels.deleteCosting',
            permissionKey: 'costing_costing_delete'
          },
          {
            name: 'archiveCosting',
            label: 'labels.archiveCosting',
            permissionKey: 'costing_costing_archive'
          }
          // {
          //   name: 'restoreCosting',
          //   label: 'labels.restoreCosting',
          //   permissionKey: 'costing_costing_restore'
          // }
        ]
      },
      {
        name: 'costingAssumptionDriverManagement',
        label: 'labels.costingAssumptionDriverManagement',
        permissionKey: 'costing_assumption_driver_management',
        children: [
          {
            name: 'costingAssumptionDriverAdd',
            label: 'labels.costingAssumptionDriverAdd',
            permissionKey: 'costing_assumption_driver_add'
          },
          {
            name: 'costingAssumptionDriverEdit',
            label: 'labels.costingAssumptionDriverEdit',
            permissionKey: 'costing_assumption_driver_edit'
          }
        ]
      },
      {
        name: 'costingGasolineManagement',
        label: 'labels.costingGasolineManagement',
        permissionKey: 'costing_gasoline_management',
        children: [
          {
            name: 'costingGasolineAdd',
            label: 'labels.addCostingGasoline',
            permissionKey: 'costing_gasoline_add'
          },
          {
            name: 'costingGasolineEdit',
            label: 'labels.editCostingGasoline',
            permissionKey: 'costing_gasoline_edit'
          },
          {
            name: 'costingGasolineDelete',
            label: 'labels.deleteCostingGasoline',
            permissionKey: 'costing_gasoline_delete'
          },
          {
            name: 'costingGasolineArchive',
            label: 'labels.archiveCostingGasoline',
            permissionKey: 'costing_gasoline_archive'
          }
          // {
          //   name: 'costingGasolineRestore',
          //   label: 'labels.restoreCostingGasoline',
          //   permissionKey: 'costing_gasoline_restore'
          // }
        ]
      }
    ]
  }
]
